export const hasReports = /* GraphQL */ `
  query hasReports($taskId: ID!) {
  hasReports(taskId: $taskId) 
}
`;

export const listTaskListUnits = /* GraphQL */ `
  query listTaskListUnits($workspaceId: ID!, $isArchived: Boolean, $limit: Int, $nextToken: String) {
  listTaskListUnits(workspaceId: $workspaceId, isArchived: $isArchived, limit: $limit, nextToken: $nextToken) {
      items {
        avatarPath
        createdAt
        createdBy
        description
        id
        isArchived
        locationId
        logicalDayShift
        name
        ownerId
        taskLists
        taskListsOrder
        timezone
        updatedAt
        updatedBy
        version
        workspaceId
      }
      nextToken
  }
}
`;

export const listTasksForUnit = /* GraphQL */ `
  query listTasksForUnit($workspaceId: ID!, $taskListUnitId: ID!, $isArchived: Boolean, $limit: Int, $nextToken: String) {
  listTasksForUnit(workspaceId: $workspaceId, taskListUnitId: $taskListUnitId, isArchived: $isArchived, limit: $limit, nextToken: $nextToken) {
      items {
        config
        correctiveReason
        createdAt
        createdBy
        description
        id
        images
        isArchived
        isCorrective
        lateCloseEnabled
        lateCloseUntilDays
        linkedIssueId
        name
        relatedPage
        scheduleRule
        taskListId
        taskListUnitId
        updatedAt
        updatedBy
        version
      }
      nextToken
  }
}
`;

export const listTasksReportsForUnit = /* GraphQL */ `
  query listTasksReportsForUnit($workspaceId: ID!, $taskListUnitId: ID!, $startDate: DateTime, $endDate: DateTime, $isArchived: Boolean, $limit: Int, $nextToken: String) {
  listTasksReportsForUnit(workspaceId: $workspaceId, taskListUnitId: $taskListUnitId, startDate: $startDate, endDate: $endDate, isArchived: $isArchived, limit: $limit, nextToken: $nextToken) {
      items {
        comment
        commentImages
        completedAt
        completedBy
        createdAt
        createdBy
        id
        images
        logicalDayStart
        status
        taskId
        taskListUnitId
        updatedAt
        updatedBy
        version
      }
      nextToken
  }
}
`;
